import { faTasks } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule } from '@domain-group/suit-theme'

import { getTaskTypeSetting, subTaskTypes, taskTypes } from '@functions/taskListItem'

import useSelector from '@hooks/useSelector'
import useTaskListItems from '@hooks/useTaskListItems'

import Table from './Table'

export const icon = faTasks

const combinedTaskTypes = [...taskTypes, { key: '' }, ...subTaskTypes].map(taskType => ({
  key: taskType,
  label: getTaskTypeSetting(taskType, 'label') ?? '---',
}))

export const configOptions = {
  title: {
    component: 'input',
    key: 'title',
    label: 'Title',
    optionKey: 'customization',
  },
  assignee_id: {
    component: 'select',
    key: 'assignee_id',
    label: 'Assignee',
    optionKey: 'queryParams',
    values: [
      { key: 'all', label: 'All' },
      { key: 'current_user', label: 'Me' },
    ],
  },
  priority: {
    component: 'select',
    key: 'priority',
    label: 'Priority',
    optionKey: 'queryParams',
    values: [
      { key: 'all', label: 'All' },
      { key: 'high', label: 'High' },
      { key: 'medium', label: 'Medium' },
      { key: 'default', label: 'Default' },
    ],
  },
  task_type: {
    component: 'select',
    key: 'task_type',
    label: 'Task Type',
    optionKey: 'queryParams',
    values: [
      { key: 'all', label: 'All' },
      ...combinedTaskTypes,
    ],
  },
  limit: {
    component: 'select',
    key: 'limit',
    label: 'Limit',
    optionKey: 'queryParams',
    values: [
      { key: 5, label: '5' },
      { key: 10, label: '10' },
      { key: 25, label: '25' },
      { key: 50, label: '50' },
    ],
  },
}

interface TaskListItemsProps {
  customOptions: {
    customization?: {
      title?: string,
    },
    queryParams?: object,
  },
  editing: boolean,
}

const TaskListItems = (props: TaskListItemsProps) => {
  const { customOptions, editing } = props

  const taskListItemsPayload = useTaskListItems({
    filters: {
      ...customOptions?.queryParams,
      completed: false,
      parent_task_id: undefined,
      sub_tasks: true,
      template_project: true,
    },
    performHttpRequests: true,
    requestOptions: {
      include_image_sizes: true,
      include_related_entity_subject: true,
      include_task_list_item_assignee: true,
      include_task_list_item_parent_task: true,
      include_task_list_item_related_entities: true,
      include_task_list_item_task_list: true,
      include_user_image: true,
    },
  })

  const { filteredTaskListItems, loading } = taskListItemsPayload

  const entities = useSelector(reduxState => reduxState.entities)

  const title = customOptions?.customization?.title

  return (
    <DashboardModule
      boxProps={{ marginBottom: 0 }}
      contentBoxProps={{ flexDirection: 'column' }}
      editing={editing}
      loading={loading}
      title={title || 'Tasks'}
    >
      <Table entities={entities} taskListItems={filteredTaskListItems} />
    </DashboardModule>
  )
}

export default TaskListItems
